import React from "react";
import {Trans, useTranslation} from "react-i18next";
import {ITermsModalProps, TermsButton, TermsText, TermsTitle} from "components/CheckTerms/common";
import {useSelector} from "react-redux";
import {isBettingCountySelector} from "modules/selectors";

export const TermsNonBetting: React.FC<ITermsModalProps> = ({trackActionRules, onPlay}) => {
	const {t} = useTranslation();
	const isBettingCountry = useSelector(isBettingCountySelector);

	if (isBettingCountry) {
		return null;
	}
	return (
		<React.Fragment>
			<TermsTitle>{t("terms_modal.title")}</TermsTitle>
			<TermsText>
				<Trans i18nKey="terms_modal.content.description">
					By clicking "Play Now", I acknowledge that I have read, understand, and agree to
					be bound by the{" "}
					<a
						onClick={trackActionRules}
						target="_blank"
						rel="noreferrer"
						href="https://www.mlb.com/apps/beat-the-streak/official-rules"
					>
						Official Rules
					</a>
					{", "}
					<a
						onClick={trackActionRules}
						target="_blank"
						rel="noreferrer"
						href="https://www.mlb.com/official-information/terms-of-use"
					>
						Terms of Use
					</a>
					, and{" "}
					<a
						onClick={trackActionRules}
						target="_blank"
						rel="noreferrer"
						href="https://www.mlb.com/official-information/privacy-policy"
					>
						MLB Privacy Policies.
					</a>
				</Trans>
			</TermsText>
			<TermsButton type={"button"} onClick={onPlay}>
				{t("terms_modal.button_success")}
			</TermsButton>
		</React.Fragment>
	);
};
